/*
 * Tutorial Question Form Messages
 *
 * This contains all the text for the Tutorial Question Form component.
 */

import { defineMessages } from 'react-intl';

const scope = 'src.pages.TutorialDetailsPage.components.TutorialQuestionForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Tutorial Question',
  },
  createQuestionButtonLabel: {
    id: `${scope}.createQuestionButtonLabel`,
    defaultMessage: 'Create question',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
  codeLabel: {
    id: `${scope}.codeLabel`,
    defaultMessage: 'Code',
  },
  questionEnLabel: {
    id: `${scope}.questionEnLabel`,
    defaultMessage: 'Question EN',
  },
  questionDeLabel: {
    id: `${scope}.questionDeLabel`,
    defaultMessage: 'Question DE',
  },
  tutorialLabel: {
    id: `${scope}.tutorialLabel`,
    defaultMessage: 'Tutorial',
  },
  descriptionEnLabel: {
    id: `${scope}.descriptionEnLabel`,
    defaultMessage: 'Description EN',
  },
  descriptionDeLabel: {
    id: `${scope}.descriptionDeLabel`,
    defaultMessage: 'Description DE',
  },
  visibleLabel: {
    id: `${scope}.visibleLabel`,
    defaultMessage: 'Visible',
  },
  correctAnswerExplanationEnLabel: {
    id: `${scope}.correctAnswerExplanationEnLabel`,
    defaultMessage: 'Correct Answer Explanation EN',
  },
  correctAnswerExplanationDeLabel: {
    id: `${scope}.correctAnswerExplanationDeLabel`,
    defaultMessage: 'Correct Answer Explanation DE',
  },
  shownToUsers: {
    id: `${scope}.shownToUsers`,
    defaultMessage: '(shown to users)',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
});
